export const format = (number?: number | string, digits: number = 0) =>
	Number(number).toLocaleString(undefined, {
		minimumFractionDigits: digits,
	})
